import { motion } from 'framer-motion'
import { Link } from '@tanstack/react-router'
import { HiOutlineArrowRight } from 'react-icons/hi'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide15WhatsNext.copy'

const ease = [0.16, 1, 0.3, 1] as const
const transitionBase = { duration: 0.45, ease }
const animationProps = { initial: { opacity: 0, y: 12 }, animate: { opacity: 1, y: 0 } }

export default function Slide15WhatsNext(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <section className="text-slate-900 w-full flex flex-col justify-center">
      <div className="w-full max-w-4xl mx-auto text-center">
        {/* Animated check: circle strokes on, then the check mark is drawn. */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease }}
          className="mb-6 flex justify-center"
        >
          <svg viewBox="0 0 48 48" className="h-16 w-16" fill="none">
            <motion.circle
              cx="24"
              cy="24"
              r="21"
              stroke="#10b981"
              strokeWidth={1.5}
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.1, ease }}
            />
            <motion.path
              d="M15 25l6 6L33 17"
              stroke="#10b981"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.4, delay: 0.5, ease }}
            />
          </svg>
        </motion.div>

        <motion.h2
          {...animationProps}
          transition={{ ...transitionBase, delay: 0.2 }}
          className="text-6xl sm:text-7xl font-semibold text-slate-900 tracking-tight mb-5"
        >
          {c.completionTitle}
        </motion.h2>

        <motion.p
          {...animationProps}
          transition={{ ...transitionBase, delay: 0.7 }}
          className="text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-3xl mx-auto mb-8"
        >
          {c.body}
        </motion.p>

        <motion.div
          {...animationProps}
          transition={{ ...transitionBase, delay: 0.12 }}
          className="max-w-md mx-auto"
        >
          <Link to="/basics/$basicsSlug" params={{ basicsSlug: 'emotional-hijack' }} className="inline-block">
            <span className="inline-flex items-center gap-2 rounded-full bg-violet-600 px-8 py-3.5 text-lg font-semibold text-white hover:bg-violet-700 transition-colors cursor-pointer">
              {c.buttonLabel}
              <HiOutlineArrowRight className="dir-flip h-5 w-5" />
            </span>
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
